import axios from 'axios'
import config from '../config'

export const publicAxios = axios.create({
    baseURL: config.apiPath
})


export default publicAxios